@use '../../../assets/styles/theme';

.checkbox {
  margin-right: 4px;
  padding: 8px;
  border-radius: 4px;
  background-color: white;
  border: 1px solid theme.$meta;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: theme.$meta;
  cursor: pointer;
  transition: all 0.15s linear;
  &.checked {
    border: 1px solid theme.$orange-500;
    color: theme.$orange-500;
    &:hover {
      background-color: theme.$orange-100;
    }
  }
  &:hover {
    background-color: theme.$lightGray;
  }
  .label {
    margin-left: 6px;
  }
}
.circle {
  height: 8px;
  width: 8px;
  border-radius: 16px;
  border: 1px solid theme.$meta;
}
.circleChecked {
  height: 8px;
  width: 8px;
  border-radius: 16px;
  background-color: theme.$orange-500;
}
